import tippy, { followCursor } from 'tippy.js';

export default class ExplorerMap {
  constructor(items = []) {
    this.items = items;

    // building
    this.buildingOverlayBoxWrapper = document.querySelector('.stage--building-overlay-box');
    this.buildingOverlayBoxText = document.querySelector('.stage--building-overlay-box-text');
    this.buildingOverlayBoxNumber = document.querySelector('.stage--building-overlay-box-number');

    // floor
    this.floorWrapper = document.querySelector('.stage--floor');

    this.projectionImages = document.querySelectorAll('.stage--floor-projection-img');
    this.projectionMasks = document.querySelectorAll('.stage--floor-projection-mask');
    this.switcherItems = document.querySelectorAll('.stage--floor-switcher a');

    // room
    this.roomWrapper = document.querySelector('.stage--room');

    // layover
    this.layover = document.querySelector('.page-explorer--layover');
    this.layoverMessageField = this.layover.querySelector('[name="your-message"]');
  }

  init() {
    this.buildingListeners();
    this.floorListeners();
    this.roomListeners();

    // mark sold and reserved
    document.querySelectorAll('.stage--floor-projection-mask g').forEach((shape) => {
      const room = this.items.find((el) => el.name === shape.dataset.name);
      const statusId = parseInt(room.statusId);

      if (!room || [3, 4, 5, 6, 7, 8, 9].includes(statusId)) {
        shape.classList.add('sold');
      } else if (statusId === 2) {
        shape.classList.add('reserved');
      }
    });

    // hide loader
    document.querySelector('.explorer-map--loader').classList.add('hidden');
  }

  buildingListeners() {
    // floors
    document.querySelectorAll('.stage--building-mask g.floor').forEach((floor) => {
      const { floorId, floorNumber } = floor.dataset;

      // click
      floor.addEventListener('click', () => {
        this.showFloor(floorId);
      });

      // hover
      floor.addEventListener('mouseover', () => {
        this.buildingOverlayBoxWrapper.classList.add('visible');
        this.buildingOverlayBoxText.textContent = 'Piętro';
        this.buildingOverlayBoxNumber.textContent = floorNumber || 0;
      });

      floor.addEventListener('mouseout', () => {
        this.buildingOverlayBoxWrapper.classList.remove('visible');
        this.buildingOverlayBoxText.innerHTML = '&nbsp;';
        this.buildingOverlayBoxNumber.innerHTML = '&nbsp;';
      });
    });
  }

  showFloor(floorId) {
    // wrapper
    this.floorWrapper.classList.add('visible');

    // switcher
    this.switcherItems.forEach((el, i) => {
      el.classList.remove('active');

      el.dataset.floorId = `${floorId.slice(0, 1)}${i}`;

      if (el.dataset.floorId == floorId) {
        el.classList.add('active');
      }
    });

    // img
    this.projectionImages.forEach((el) => {
      el.classList.remove('active');

      if (el.classList.contains(`stage--floor-projection-img-${floorId}`)) {
        el.classList.add('active');
      }
    });

    // mask
    this.projectionMasks.forEach((el) => {
      el.classList.remove('active');

      if (el.classList.contains(`stage--floor-projection-mask-${floorId}`)) {
        el.classList.add('active');
      }
    });

    setTimeout(() => {
      const y = this.floorWrapper.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: y - 92,
        behavior: 'smooth',
      });
    }, 300);
  }

  hideFloor(e) {
    e.preventDefault();

    window.scroll({
      top: 0,
      behavior: 'smooth',
    });

    setTimeout(() => {
      // wrapper
      this.floorWrapper.classList.remove('visible');
    }, 300);
  }

  floorListeners() {
    document.querySelector('.stage--floor-desc-back').addEventListener('click', this.hideFloor.bind(this));
    document.querySelector('.stage--floor-switcher button').addEventListener('click', this.hideFloor.bind(this));

    // switcher
    this.switcherItems.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        const { floorId } = e.target.dataset;

        this.showFloor(floorId);
      });
    });

    this.projectionMasks.forEach((mask) => {
      mask.querySelectorAll('g').forEach((shape) => {
        const room = this.items.find((el) => el.name === shape.dataset.name);

        // tooltip
        const availableContent = `
        <div class="room-tooltip">
          <span>${room?.localNumber}</span>
          <span>Pow.: ${room?.area}m&sup2;</span>
          <span>Ilość pokoi: ${room?.rooms}</span>
        </div`;

        const soldContent = `
        <div class="room-tooltip sold">
          <span>${shape.dataset.name}</span>
          <strong>Sprzedane</strong>
        </div`;

        tippy(shape, {
          content: ['1', '2'].includes(room?.statusId) ? availableContent : soldContent,
          delay: 0,
          duration: 0,
          plugins: [followCursor],
          followCursor: true,
          allowHTML: true,
          hideOnClick: false,
        });

        // click
        if (['1', '2'].includes(room?.statusId)) {
          shape.addEventListener('click', () => this.showRoom(room));
        }
      });
    });

    // layover
    const layover = document.querySelector('.page-explorer--layover');
    const messageField = document.querySelector('[name="your-message"]');
    document.querySelector('.stage--room-data-main .btn-send').addEventListener('click', (e) => {
      e.preventDefault();

      const { apartmentName } = e.target.dataset;

      const message = `Jestem zainteresowana/y apartamentem nr ${apartmentName}. Proszę o kontakt.`;

      layover.classList.add('toggled');
      messageField.value = message;
    });
  }

  showRoom(roomData) {
    // floor
    if (!this.roomVisible) {
      setTimeout(() => {
        const y = this.roomWrapper.getBoundingClientRect().top + window.scrollY;
        window.scroll({
          top: y - 92,
          behavior: 'smooth',
        });
      }, 300);
    }

    // wrapper
    this.roomWrapper.classList.add('visible');

    // area
    document.querySelectorAll('.room-data-area').forEach((el) => {
      el.innerHTML = `${roomData.area} m&sup2;`;
    });

    // floor
    document.querySelectorAll('.room-data-floor').forEach((el) => {
      el.textContent = roomData.floor;
    });

    // name
    document.querySelectorAll('.room-data-local-number').forEach((el) => {
      el.textContent = roomData.localNumber;
    });

    // rooms
    document.querySelectorAll('.room-data-rooms').forEach((el) => {
      el.textContent = roomData.rooms;
    });

    // inquiry button
    document.querySelector('.stage--room-data-main .btn-send').dataset.roomId = roomData.localNumber;

    // projection img
    if (roomData.projectionUrl) {
      document.querySelector('.stage--room-projection-img').innerHTML = `<img src="${roomData.projectionUrl}" alt="">`;
    }

    // card url
    if (roomData.cardUrl) {
      document.querySelector('.room-data-card-url').setAttribute('href', roomData.cardUrl);
    }
  }

  roomListeners() {
    document.querySelector('.stage--room-data-back').addEventListener('click', this.hideRoom.bind(this));
    document.querySelector('.stage--room-projection-close').addEventListener('click', this.hideRoom.bind(this));

    document.querySelector('.stage--room-data .btn-send').addEventListener('click', (e) => {
      e.preventDefault();

      const { roomId } = e.target.dataset;

      this.openAndFillLayover(`Jestem zainteresowana/y apartamentem nr ${roomId}. Proszę o kontakt.`);
    });
  }

  hideRoom(e) {
    e.preventDefault();

    const y = this.floorWrapper.getBoundingClientRect().top + window.scrollY;
    window.scroll({
      top: y - 92,
      behavior: 'smooth',
    });

    setTimeout(() => {
      // wrapper
      this.roomWrapper.classList.remove('visible');
    }, 300);
  }

  openAndFillLayover(message) {
    this.layover.classList.add('toggled');
    this.layoverMessageField.value = message;
  }
}
